<template>
  <el-tabs v-model="activeName" :stretch="true" @tab-click="handleClick" :before-leave="checkTab">

    <div class="recharge_hurg  ">
      <div class="title">选择TM通话/流量套餐</div>
      <ul>
        <li :class="[item.id == status ? 'bechoice':'']" v-for="(item,index) in tm.liul" :key="index"
          @click="choicePrice(item.id,item.count,item.desc,item.combination)">
          <div>
            ￥{{item.count}}
          </div>
          <div class="des">
            {{item.sub_title}}
          </div>
        </li>
      </ul>
    </div>
    <el-drawer title="我是标题" :visible.sync="drawer" :with-header="false" :direction="direction" :size="size"
      style="max-width:750px;margin:0 auto;">
      <div class="drawer">
        <div class="cancle">
          <i class="iconfont el-icon-close" @click="closeDrawer"></i>
        </div>
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">充值金额</div>
          <div class="drawer-cell_bd">{{thePrice}}</div>
        </div>
        <div class="drawer-cell ">
          <div class="drawer-cell_hd">实付金额</div>
          <div class="drawer-cell_bd">{{codemoney?codemoney:thePrice}}</div>
        </div>
        <div class="drawer-cell under-line">
          <div class="drawer-cell_hd">手机号码</div>
          <div class="drawer-cell_bd redclass">{{theNumber!='NaN'?theNumber:"请输入手机号码充值"}}</div>
        </div>
        <div class="drawer-cell">
          <div class="drawer-cell_hd">服&ensp;务&ensp;商</div>
          <div class="drawer-cell_bd">{{operators}}</div>
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="combination">
          重要提示：此为组合套餐，失败将退款到余额
        </div>
        <div class="drawer-cell" style="color: #c82f08;text-align: left;" v-if="!combination && radio==2">
          重要提示：使用余额支付，失败将退款到余额
        </div>
        <div class="drawer-cell" style="height:auto" v-if="theNumber!='NaN'">
          <div class="drawer-cell_hd">
            优&ensp;惠&ensp;码
          </div>
          <div class="drawer-cell_bd intro flex">
            <el-input v-model="code" placeholder="请输入优惠代码" size="small" maxlength="12" class='mar-right-5'
              v-if="codetoken==''"></el-input>
            <el-button type="primary" size="mini" plain @click="verificationcodefun" v-if="codetoken==''">兑换
            </el-button>
            <div class='mar-right-5 xcode' v-if="codetoken!=''">{{code}}</div>
          </div>
        </div>

        <div class="drawer-cell" style="height:auto" v-if="coupons.length > 0">
          <div class="drawer-cell_hd"  style="line-height:40px">
            优&ensp;惠&ensp;券
          </div>
          <div class="drawer-cell_bd intro flex">
            <el-select v-model="coupon_id" @change="couponChange" placeholder="请选择">
              <el-option
                v-for="item in coupons"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="drawer-cell" style="height:auto">
          <div class="drawer-cell_hd">套餐介绍</div>
          <div class="drawer-cell_bd intro ">{{theDetail}}</div>
        </div>

        <div class="drawer-cell">
          <div class="drawer-cell_hd">支付方式</div>
          <!-- 余额支付 -->
          <div class="myredioBox" v-if="onlyBalancePay">
            <!-- <div class="myredioleabl">
              <div class="myrediotext">在线支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div> -->
            <div class="myredioleabl myredioleablAc">
              <div class="myrediotext">余额支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
          </div>
          <!-- 在线支付 -->
          <div class="myredioBox" v-else>
            <div class="myredioleabl" :class="radio==1?'myredioleablAc':''" @click="checkedValuefun(1)">
              <div class="myrediotext">直充</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
            <div class="myredioleabl" :class="radio==2?'myredioleablAc':''" @click="checkedValuefun(2)"
              v-if="codetoken==''">
              <div class="myrediotext">余额支付</div>
              <div class="myredio">
                <div></div>
              </div>
            </div>
          </div>
        </div>

        <div class="drawer-cell payment-radio" v-if="$client == 'h5' && payments.length > 1">

          <el-radio-group
          v-model="payment"
          size="small"
          @change="handleRadioChange"  class="group-flex">
            <el-radio
              :label="item.code"
              v-for="item in payments"
              :key="item.code"
              class="radio-flex"
            >
              <img :src="'../../static/images/'+item.name+'.png'" >
            </el-radio>
          </el-radio-group>
        </div>

        <div class="btn-area" v-if="theNumber!='NaN'">
          <el-row>
            <el-col :span="12">
              <div class="grid-content bg-purple">
                <el-button type="info" class="half" @click="closeDrawer">取消支付</el-button>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content bg-purple-light">
                <el-button type='primary' @click="order" v-loading.fullscreen.lock="fullscreenLoading"
                  class="half">确认支付</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="请使用扫码支付" :visible.sync="centerDialogVisible" width="300px" center>
      <div>
        <!--  <span>需要注意的是内容是默认不居中的</span> -->
        <vue-qr :text="downloadData.url" :margin="10" colorDark="#000" colorLight="#fff" :dotScale="1"
          :logoSrc="downloadData.icon" :logoScale="0.2" :size="200"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </el-tabs>
</template>

<script>
  const delay = (function() {
    let timer = 0
    return function(callback, ms) {
      clearTimeout(timer)
      timer = setInterval(callback, ms)
    }
  })()

  import vueQr from 'vue-qr'
  import wx from 'weixin-js-sdk';

  export default {
    name: 'tabs',
    components: {
      vueQr,
      wx
    },
    data() {
      return {
        magatype: "",
        code: "",
        isLogin: false,
        codemoney: 0,
        codestatus: true,
        codetoken: "",
        radio: 1,
        centerDialogVisible: false,
        downloadData: {
          url: '', //需要转化成二维码的网址
          // icon: require('./xxx.jpg')  //二维码中间的图片,可以不设置
        },
        newActiveName: "",
        activeName: "first",
        direction: "btt",
        drawer: false,
        thePrice: 10,
        status: 0,
        theDetail: "",
        combination: null,
        onlyBalancePay: false,
        size: "55%",
        theNumber: "NaN",
        operators: "NaN",
        opertaorsId: 1,
        tabValue: true,
        ispay: false,
        payment: 'weixin',
        i: 0,
        fullscreenLoading: false,
        tag: true,
        isOrder: false,
        coupon_id: '',
        coupon: {},
      }
    },
    props: {
      coupons: Array,
      theType: Object,
      globe: Object,
      smart: Object,
      sun: Object,
      tm: Object,
      dito: Object,
      payments: Array,
    },
    computed: {
      tab2StatusChanged() {
        return this.$store.state.tab2Status;
      }
    },
    watch: {
      code(n, o) {
        this.code = this.code.toUpperCase();
      },
      tab2StatusChanged(now) {
        if (now <= 0) {
          this.status = now;
        }
      },
      // 父组件通过PROPS（theType）传值到子组件，通过watch监控props值改变，修改相对应的值
      //**如果PROPS为OBJ，WATCH无法监控其属性,因为在父组件时，修改的是其属性。而对象未发生改变**
      theType() {
        this.theNumber = this.theType.number;
        this.tabValue = this.theType.value;
        this.i = 0;
        this.chooseChannel(this.theType.id);
      }
    },
    mounted() {
      this.chooseChannel(this.theType.id);
    },
    methods: {
      couponChange(e) {
        this.coupons.forEach((item) => {
          if (item.id == e) {
            this.coupon = item;
            this.coupon_id = item.id;
          }
        })
        this.updatePrice();
      },
      chooseChannel(type) {
        switch (type) {
          case 1:
            this.activeName = "first";
            this.opertaorsId = 1;
            this.operators = "GLOBE/TM";
            break;
          case 2:
            this.activeName = "second";
            this.opertaorsId = 2;
            this.operators = "SMART/TNT";
            break;
          case 3:
            this.activeName = "third";
            this.opertaorsId = 3;
            this.operators = "SUN";
            break;
          case 4:
            this.activeName = "four";
            this.opertaorsId = 4;
            this.operators = "DITO";
            break;
        }
      },
      onloadcode() {
        this.codemoney = 0;
        this.code = "";
        this.codestatus = true;
        this.codetoken = "";
      },
      verificationcodefun() {
        if (this.combination) {
          this.$message({
            message: "不支持当前套餐",
            type: "warning"
          })
          return false;
        }
        if (this.radio == 2) {
          this.$message({
            message: "不支持当前支付方式",
            type: "warning"
          })
          return false;
        }
        if (this.code) {
          this.$api
            .request('Order/verifyPromoCode', {code: this.code, money: this.thePrice})
            .then(({ data }) => {
                this.codestatus = false;
                this.codemoney = data.codemoney;
                this.codetoken = data.codetoken;
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "warning"
              })
            });
        } else {
          this.$message({
            message: "请输入优惠代码",
            type: "warning"
          })
        }
      },
      checkedValuefun(e) {
        this.radio = e;
      },
      order() {
        this.drawer = false;
        if (this.isOrder) {
          this.$message({
            message: "请勿重复下单",
            type: "warning"
          })
          return false;
        }
        this.isOrder = true;

        let auth_token = localStorage.getItem('auth_token');
        if ((this.$client == 'wxh5' || this.$client == 'magapp') && !auth_token) {
            this.$message({
              message: "请登录后下单！",
              type: "warning"
            })
            this.$emit("checkLogin", {});
            return false;
        }
        if (!auth_token && this.radio == 2) {
            this.$message({
              message: "未登录不能使用余额支付",
              type: "warning"
            })
            return false;
        }
        if (this.radio == 1 && this.combination) {
            this.$message({
              message: "组合套餐不能只用在线支付",
              type: "warning"
            })
            return false;
        }
        let phone = this.theNumber;
        if (typeof this.theType.numbers != 'undefined' && this.theType.numbers.length > 0) {
          phone = this.theType.numbers.join(',');
        }
        let settlement = 1;
        if (this.$client == 'wxh5' || (this.$client == 'h5' && this.payment == 'weixin')) {
          settlement = 2;
        }
        this.$api.request('Order/create', {
            type: this.radio,
            settlement: settlement,
            phone: phone,
            itemid: this.status,
            client: this.$client,
            code: this.code,
            payment: this.payment,
            codetoken: this.codetoken,
            coupon_id: this.coupon_id,
           })
          .then(({ data }) => {
            this.isOrder = false;
            if (this.coupon_id > 0) {
              let coupon_select_index = this.coupons.findIndex(citem => {
                return citem.id === this.coupon_id;
              })
              this.coupons.splice(coupon_select_index, 1);
              this.coupon = {};
              this.coupon_id = 0;
            }
            if (data.result == true) {
                this.$message({
                  message: "余额支付成功！",
                  type: "success"
                })
            } else {
              let out_trade_no = '';
              switch(this.$client) {
                case 'h5':
                  if (this.payment == 'weixin') {
                    if (data.result.is_wap) {
                      this.openUrl(data.result.h5_url);
                    } else {
                      this.centerDialogVisible = true;
                      this.downloadData.url = data.result.code_url;
                      out_trade_no = data.result.out_trade_no;
                    }
                  } else {
                    switch (data.type) {
                      case "1":
                        if (this.payment == 'gcashpay') {
                          this.openUrl(data.result.data.content);
                        } else {
                          this.centerDialogVisible = true;
                          this.downloadData.url = data.result.data.content;
                          out_trade_no = data.result.data.outTradeNo;
                        }
                        break;
                      case "2":
                        switch (this.payment) {
                          case "alipay":
                            this.centerDialogVisible = true;
                            this.downloadData.url = data.result.results.pay_url;
                            break;
                          case "gcashpay":
                            this.openUrl(data.result.results.api_url);
                            break;
                        }
                        break;
                      default:
                        this.$message({
                          message: "暂不支持的支付类型！",
                          type: "warning"
                        })
                        break;
                    }
                  }

                  if (out_trade_no != '') {
                    delay(() => {
                      this.checkorder(out_trade_no)
                    }, 3000)
                  }
                  break;
                case 'wxh5':
                  this.wxpay(data.result);
                  break;
                case 'magapp':
                  this.magpay(data.result);
                  break;
                default:
                  this.$message({
                    message: "暂不支持的客户端！",
                    type: "warning"
                  })
                  break;
              }
            }
          })
          .catch(error => {
            this.isOrder = false;
            this.$message({
              message: error,
              type: "warning"
            })
          });
      },
      magpay(params) {
        let config = {
          money: params.pay_amount,
          title: params.description,
          des: params.description,
          payWay: {
            // wallet: 1,
            weixin: 1,
            alipay: 1,
          },
          orderNum: params.oid,
          unionOrderNum: params.order_sn,
          type: params.description
        };
        mag.pay(config, () => {
          setTimeout(() => {
            this.$message({
              message: "支付成功",
              type: "warning"
            })
          }, 50);
        }, () => {
          this.$message({
            message: "支付失败",
            type: "warning"
          })
        });
      },
      wxpay(params) {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            'appId': params.appId,
            'timeStamp': params.timeStamp,
            'nonceStr': params.nonceStr,
            'package': params.package,
            'signType': params.signType,
            'paySign': params.paySign
          },
          (res) => {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
            } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            } else if (res.err_msg === 'get_brand_wcpay_request:fail') {
              this.$router.go(0);
            }
        });
      },
      checkorder(sn) {
        this.$api
          .request('Order/check', {sn})
          .then(({ data }) => {
              this.$message({
                message: "支付成功",
                type: "warning"
              })
              this.$router.go(0);
          })
          .catch(error => {
            console.log(error)
          });
      },
      closeDrawer() {
        this.drawer = false
      },
      // 切换TABS前，进行判断，当前运营商（activename）与this.type.id是否一致？？？
      // XXXX需要的是在正确的条状一次后，禁止掉后续的跳转(不可行，因为在)
      checkTab(act, oact) {
        //在跳转之前进行判断，TABS不可以跳转
        // 当输入号码后进入这段判断
        //接房方法找到原有的，判断，或者INIT原有状态。
        if (act == oact || this.activeName == oact) {
          this.i++
        }
        if (!this.tabValue) {
          // 问题出在这里，tabvalue 需要执行一次。
          //i<1时不执行，i>0时执行
          //新的问题：当前activename即输入号码段时，不用PROPS修改，但是用户又手残去点击了一次。
          // 如何解决？817号段，即号码输入号码就是第一个运营商的（方法错误。）即不需要发生修改运营商
          if (this.i < 1) {
            this.i++;
            return true
          };
          // 弹出error框体
          if (this.i > 0) {
            this.$message({
              message: "号段与运营商需匹配",
              type: "warning"
            })
            return false
          }
        }
        if (!this.tabValue && this.i > 0) {
          this.$message({
            message: "号段与运营商不匹配",
            type: "warning"
          })
          // 问题出在这里，tabvalue 需要执行一次。
          this.i++;
          // this.tabValue=true;
          return false
        }
      },
      isInApplets() {
        wx.miniProgram.getEnv(function(res) { //获取当前环境
          if (res.miniprogram) { // true 在微信小程序中
            return 1;
          } else { // false 在微信公众号里
            return -1;
          }
        });
      },
      handleClick(tab, event) {
      },
      handleRadioChange(e) {
        this.payment = e;
      },
      // 弹窗，1、验证（如果可以，禁止点击其他tabs），可点击，判断号码与运营商是否一致。2、装载相应数据。
      choicePrice(index, price, desc, combination) {
        this.status = index;
        if (typeof this.theType.numbers != 'undefined' && this.theType.numbers.length > 0) {
          this.theNumber = '批量充值';
          this.thePrice = price * this.theType.numbers.length;
          this.code = "";
          this.codemoney = 0;
          this.codestatus = true;
          this.codetoken = "";
          this.drawer = true
          this.theDetail = desc
          this.combination = combination
          this.onlyBalancePay = true
          this.radio = 2;

          if (this.payments) {
            if (this.payments.length == 1) {
              let current_payment = this.payments.shift();
              this.payment = current_payment.code;
            }
          }
        } else {
          var num = this.theType.number;
          this.$store.commit('setTabStatus', index);
          this.$store.commit('setTab2Status', 0);
          var bl = this.common.test(num);
          if (num == "" || num == "NaN" || !num) {
            this.thePrice = price
            this.code = "";
            this.codemoney = 0;
            this.codestatus = true;
            this.codetoken = "";
            this.radio = 1;
            this.drawer = true
            this.theDetail = desc
            this.combination = combination
            if (this.combination) {
              this.onlyBalancePay = true
            }
          } else {
            //判断号码是否为菲律宾号码段，符合10位
            var reg = /^(8|08|9|09)[0-9]{9}$/;
            if (this.common.test(num) && num.match(reg)) {
              this.thePrice = price
              this.code = "";
              this.codemoney = 0;
              this.codestatus = true;
              this.codetoken = "";
              this.drawer = true
              this.theDetail = desc
              this.combination = combination
              if (combination) {
                this.onlyBalancePay = true
                this.radio = 2;
              } else {
                this.radio = 1;
              }

              if (this.payments) {
                if (this.payments.length == 1) {
                  let current_payment = this.payments.shift();
                  this.payment = current_payment.code;
                }
              }
            } else {
              this.$message({
                message: "请输入正确的菲律宾手机号码",
                type: "warning"
              })
            }
          }
        }
        this.updatePrice();
      },
      updatePrice() {
        if (this.coupons.length > 0 && this.coupon_id == '' && this.thePrice > 0) {
          for (let item of this.coupons) {
            if (item['limit'] <= this.thePrice) {
              this.coupon = item;
              this.coupon_id = item.id;
            }
          }
        }
        if (this.coupon_id > 0 && this.thePrice > 0) {
          if (this.thePrice < this.coupon['limit']) {
              this.$message({
                message: "此优惠券不满足使用条件",
                type: "warning"
              })
              this.coupon_id = '';
              this.coupon = {};
              this.codemoney = "";
          } else {
            this.codemoney = this.thePrice - this.coupon['amount'];
          }
        }
      }
    }
  };
</script>
<style scoped>

  .el-select-dropdown__item {
    width: 100%;
    margin-bottom: 0px;
  }

  .payment-radio {
    padding: 20px 0 0 0;
  }

  .myredioBox {
    text-align: right;
    width: 70%;
    color: #666;
    display: flex;
  }

  .myredioleabl {
    height: 2rem;
    line-height: 2rem;
    width: 50%;
    display: flex;
  }

  .myrediotext {
    float: right;
  }

  .myredio {
    float: right;
    width: 0.8rem;
    height: 0.8rem;
    background-color: #ffffff;
    border-radius: 0.8rem;
    margin-right: 0.5rem;
    margin-top: 0.6rem;
    border: 1px solid #888888;
  }

  .myredioleabl .myredio {
    border: 1px solid #888888;
  }

  .myredioleablAc .myredio {
    border: 1px solid #b22830;
  }

  .myredioleabl .myredio div {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.6rem;
    margin: 0 auto;
    margin-top: 0.1rem;
    background-color: #FFFFFF;
  }

  .myredioleablAc .myredio div {
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 0.6rem;
    margin: 0 auto;
    margin-top: 0.1rem;
    background-color: #b22830;
  }

  ul {

    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    justify-content: center;
    padding: 0;
  }

  ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    list-style-type: none;
    width: 29.5%;
    margin-right: 2%;
    border-radius: 0.15625rem;
    height: 2.5rem;
    text-align: center;
    line-height: 2.5rem;
    margin-bottom: 1rem;
    border: 1px solid var(--theme-color);
    color: #333;
    position: relative;
  }

  ul li div {
    margin: 0;
    line-height: 1em;
    height: 1em;


  }

  ul li div.bechoice {
    color: #FFFFFF;
  }

  div.des {
    line-height: 1rem;
    height: 1rem;
    font-size: .8em;
    color: #999;

  }

  .bechoice {
    /*border:2px solid #e43;*/
    color: #fff !important;
    background-color: var(--theme-color)
  }

  li.bechoice div.des {
    color: #fff;
  }

  .drawer {
    padding: 20px 20px 0px;
    height: 100%;
    position: relative;

  }
  .drawer .iconfont{
    position: absolute;
    right: 5px;
    top:5px;
    font-size:18px;
  }

  .drawer .btn-area {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

  }

  .drawer-cell {
    position: relative;
    width: 100%;
    display: flex;
    height: 2em;
    line-height: 2em;
  }

  .drawer-cell.under-line:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 1px;
    color: #e5e5e5;
    border-top: 1px solid #e5e5e5;
    transform: scaleY(.5);
    z-index: 2;
  }

  .drawer-cell_hd,
  .drawer-cell_bd {
    display: inline-block;
  }

  .drawer-cell_hd {
    width: 30%;
    text-align: left;
    color: #333;
  }

  .drawer-cell_bd {
    text-align: left;
    width: 70%;
    color: #666
  }

  .half {
    width: 100%;
  }

  .intro {
    overflow-wrap: break-word;
  }

  .tag {
    position: absolute;
    width: 40px;
    height: 40px;
    top: -25px;
    right: -10px;
  }

  .flex {
    display: flex;
  }

  .mar-right-5 {
    margin-right: 5px;
  }

  .xcode {
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    outline: 0;
    padding: 0 15px;
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
    text-align: left;
  }

  .borderSr {
    border: 1px solid #b22830;
    box-shadow: 0 0 5px #b22830;
    padding: 20px 20px 0;
    z-index: 2;
    border-radius: 9px;
    margin-bottom: 20px;
  }

  .asideShadow {
    box-shadow: 5px 0px 5px -5px black, -5px 0px 5px -5px black;
  }

  .more {
    font-size: 14px;
    color: #b22830;
    ;


  }

  .arrowBottom {
    width: 20px;
    height: 11px;
  }

  .arrowTop {
    transform: rotate(180deg);
  }

  .recharge_hurg .title {
    color: #b22830;
    font-size: 16px;
  }

  .redclass {
    color: red;
  }
  .radio-flex{
      display: flex;
      align-items: center;
  /*    flex-wrap: nowrap;
      flex-direction: row; */
    }
    .radio-flex img{
      width:60px;
    }
    .group-flex{
      display: flex;
    }
    @media screen and (min-width:768px) {
      .radio-flex img {
        width: auto;
        height: 25px;
      }

      .drawer-cell {
        height: 2em;
        line-height: 2em;
      }

      .intro {
        font-size: 16px;

      }
    }
</style>



// WEBPACK FOOTER //
// src/components/tabs2.vue